// extracted by mini-css-extract-plugin
export default {"delete-connections-button":"styles_delete-connections-button__LVEIo"};